/**
 * Важно!!! Путь должен начинаться с '/' или 'https://'
 * Важно!!! Путь не должен заканчиваться '/'
 * http://domain.name - правильно
 * http://domain.name/uri - правильно
 * http://domain.name/uri/ - НЕ правильно
 * /uri/ - НЕ правильно
 * /uri - правильно
 */
export const environment = {
    production: true,
    hmr: false,
    baseUrl: 'https://hub.staging.open-s.info',
    env: 'staging',
    gMapApiKey: 'AIzaSyCz5iS1OOsPRFifhODTGm9elD84e-aMN90',
    posBaseUrl: 'https://pos-staging.open-s.info',
    livetrackingBaseUrl: 'https://api-track.ru.ge-co.io',
    widgetBaseUrl: 'https://widget.staging.open-s.info',
    qrMenuBaseUrl: 'https://qr-menu-staging.getit.rest',
    kioskBaseUrl : 'https://kiosk-staging.open-s.info',
    kioskVPNBaseUrl : 'https://api-kiosk-vpn.getit.rest',
    contentManagerPath: '/content-manager/',
    kioskSettingsPath: '/kiosk-settings/',
    kioskControlCenterPath: '/kiosk-cc/',
    dashboardPath: '/dashboard/',
    qrMenuPath: '/qr-settings/',
    lastHashCommit : '1dd895a7bfeea180b41497b5463460fe9195645a',
    publishedFor: 'staging',
    enableRelatedProductsV3: true,
    enableNutritionEditing: true
}
